function read(value) {
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
}

export function getCookie(key) {
    if (typeof document === 'undefined' || arguments.length && !key) {
        return undefined;
    }
    const cookies = (document.cookie ? document.cookie.split(';') : [])
        .map(kvString => kvString.trim());
    let foundV;
    cookies.find(kvString => {
        const [k, v] = kvString.split('=');
        if (read(k) === key) {
            foundV = read(v);
            return true;
        }
        return false;
    });
    return foundV;
}
